<template>
  <div class="event-detail">
    <div class="text-xl font-bold">High Solar Radiation Detected</div>
    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Event ID</div>
        <div>#{{ value.id }}</div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Model Name</div>
        <div>{{ value.aiAudit?.agentId }}</div>
      </div>
      <div class="flex flex-col gap-2">
        <div class="text-gray-300 font-bold">Timestamp</div>
        <div>{{ value.timestamp | datetime }}</div>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="text-gray-300 font-bold">Level</div>
      <div>
        <span
          class="px-4 py-1 rounded-full"
          :class="{
            'text-red-300 bg-red-900': this.value?.level === EventLogLevel.HIGH,
            'text-yellow-300 bg-yellow-900':
              this.value?.level === EventLogLevel.MEDIUM,
            'text-green-300 bg-green-900':
              this.value?.level === EventLogLevel.LOW,
          }"
        >
          {{ eventLevel }}
        </span>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="text-gray-300 font-bold">Status</div>
      <div>
        <span class="px-4 py-1 rounded-full text-blue-300 bg-blue-900">
          {{ eventStatus }}
        </span>
      </div>
    </div>
    <div class="flex flex-col gap-2">
      <div class="text-xl font-bold">Description</div>
      <div>
        {{ value.event || "No description available." }}
      </div>
    </div>
    <el-divider />
    <div class="text-xl font-bold">Provide Feedback</div>
    <div>Feedback Type</div>
    <div class="flex flex-row gap-4">
      <button
        class="flex-1 text-white bg-gray-600 rounded p-4"
        :class="{
          'bg-green-800 text-green-400': aiAudit.type === 'True',
        }"
        @click="setType('True')"
      >
        <i class="fa fa-thumbs-up"></i> True
      </button>
      <button
        class="flex-1 text-white bg-gray-600 rounded p-4"
        :class="{
          'bg-red-800 text-red-400': aiAudit.type === 'False',
        }"
        @click="setType('False')"
      >
        <i class="fa fa-thumbs-down"></i> False
      </button>
    </div>
    <el-form label-width="100px" label-position="top" class="flex-1">
      <el-form
        ref="feedbackForm"
        :model="aiAudit"
        :rules="formRules"
        label-width="100px"
        label-position="top"
        class="flex-1"
      >
        <el-form-item
          label="Additional Details for False Events"
          v-if="aiAudit.type === 'False'"
          prop="feedback"
        >
          <el-input
            type="textarea"
            v-model="aiAudit.feedback"
            placeholder="Write feedback here..."
            :autosize="{ minRows: 6 }"
            class="w-full"
          />
        </el-form-item>
      </el-form>
    </el-form>
    <div class="flex flex-row justify-end">
      <el-button type="default" @click="handleCancel">Closes</el-button>
      <el-button type="primary" :loading="submitting" @click="handleConfirm">
        Submit Feedback
      </el-button>
    </div>
  </div>
</template>

<script>
import { EventLogLevel, EventLogStatus, enumValueToLabel } from "@/enums";
import { createAiAudit, updateAiAudit } from "@/api";
import _ from "lodash";
export default {
  name: "EventDetail",
  components: {},
  props: {
    value: {
      /**
       * @type {DashboardEvent|null} item - AI审核记录，可能为null，结构见 AiAuditRecord
       */
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      aiAudit: {
        eventId: this.value?.id,
        agentId: this.value?.agentInfo?.agentId || null,
        deviceKey: this.value?.deviceKey || null,
        type: this.value?.aiAudit?.type || null,
        feedback: this.value?.aiAudit?.feedback || "",
        userId: this.$store?.getters?.user?.id || "2"
      },
      formRules: {
        feedback: [
          {
            required: true,
            message: "Feedback is required for False.",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.aiAudit.type === "False" && !value.trim()) {
                callback(new Error("Feedback is required for False."));
              } else {
                callback();
              }
            },
          },
        ],
      },
      submitting: false,
    };
  },
  computed: {
    EventLogLevel: () => EventLogLevel,
    EventLogStatus: () => EventLogStatus,
    eventLevel() {
      return enumValueToLabel(EventLogLevel, this.value?.level);
    },
    eventStatus() {
      return enumValueToLabel(EventLogStatus, this.value?.status);
    },
  },
  methods: {
    setType(type) {
      this.aiAudit.type = type;
      if (type !== "False") {
        this.aiAudit.feedback = "";
      }
    },
    async handleConfirm() {
      if (this.submitting) return;
      this.submitting = true;
      try {
        if (this.aiAudit.type === "False") {
          await this.$refs.feedbackForm.validate();
        }
        if (_.isNil(this.value.aiAudit)) {
          await createAiAudit(this.aiAudit);
        } else {
          this.aiAudit.id = this.value.aiAudit.id;
          await updateAiAudit(this.aiAudit);
        }
        this.$emit("confirm", this.aiAudit);
      } finally {
        this.submitting = false;
      }
    },
    handleCancel() {
      this.$emit("cancel");
    },
  },
};
</script>
<style scoped>
.event-detail {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 16px;
}
</style>
